import React, { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";

import { getAllTax } from "../../../Api/Signin/Transaction.Api";
import useLoadingState from "../../../Utils/Hooks/useLodingState";
import { SideDrawer } from "../../atoms/Drawer/SideDrawer";
import { TaxConfiguarationAddContent } from "./Content/TaxConfiguarationAddContent";
import { TaxConfiguarationNoContent } from "./Content/TaxConfiguarationNoContent";
import { TaxConfiguarationViewContent } from "./Content/TaxConfiguarationViewContent";

export const TaxConfiguarationDrawer = ({ close, OpenDrawer }) => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);

  const { LoadingState, startLoading, stopLoading } = useLoadingState();

  const { control, watch, handleSubmit, reset, setError } = useForm({
    defaultValues: { tax: "", value: "" },
    resolver: yupResolver(
      object({
        tax: string().required(t("validation:required-field")).trim(),
        value: string()
          .required(t("validation:required-field"))
          .matches(
            /^[0-9\b]+$|^[0-9]*\.[0-9]{1}$|^[0-9]*\.[0-9]{2}$/,
            t("validation:tax-invalid-character"),
          ),
      }),
    ),
    mode: "onChange",
  });

  useEffect(() => {
    getTaxLoader();
  }, [OpenDrawer == true]);

  const getTaxLoader = async () => {
    try {
      startLoading({ btnName: "username" });
      const response = await getAllTax();
      if (response.type === 0) {
        setData(response.data);
      }
      stopLoading();
    } catch (exception) {
      stopLoading();
    }
  };

  const [contentOptions, setContentOptions] = useState({
    sceneID: 0,
    isUpdate: false,
    id: "",
  });

  const contentScreenHandler = () => {
    if (data.length > 0 && contentOptions.sceneID === 0) {
      return (
        <TaxConfiguarationViewContent
          setContentID={setContentOptions}
          id={contentOptions.id}
          data={data}
          reset={reset}
          taxLoader={getTaxLoader}
          t={t}
        />
      );
    } else if (contentOptions.sceneID === 1) {
      return (
        <TaxConfiguarationAddContent
          t={t}
          reset={reset}
          setContentID={setContentOptions}
          control={control}
          id={contentOptions.id}
          isUpdate={contentOptions.isUpdate}
          handleSubmit={handleSubmit}
          taxLoader={getTaxLoader}
          setError={setError}
          closeDrawer={close}
        />
      );
    } else {
      return (
        <TaxConfiguarationNoContent t={t} setContentID={setContentOptions} />
      );
    }
  };

  return (
    <>
      <SideDrawer
        headingText={t("common:button.tax-configuaration")}
        width={"600px"}
        openDrawer={OpenDrawer}
        close={close}
        isBold
        anchorDrawer={"right"}
        isLoading={LoadingState.visible}
      >
        <div
          style={{
            display: "grid",
            gap: "16px",
          }}
        >
          {contentScreenHandler()}
        </div>
      </SideDrawer>
    </>
  );
};
